import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;
if (!url || !anon) throw new Error("Faltan VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY (ver .env.example).");

// La anon key es pública por diseño: la seguridad vive en RLS y en las funciones SQL.
export const supabase = createClient(url, anon, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true, flowType: "pkce" },
});

/** Nivel de la sesión (claim "aal" del JWT): "aal2" = ya pasó la verificación en dos pasos. */
export function nivelDeSesion(accessToken: string): string | null {
  try {
    const p = accessToken.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    return (JSON.parse(atob(p.padEnd(Math.ceil(p.length / 4) * 4, "="))) as { aal?: string }).aal ?? null;
  } catch {
    return null;
  }
}

/** JWT vigente para llamar a /api/*. */
export async function accessToken(): Promise<string | null> {
  const { data } = await supabase.auth.getSession();
  return data.session?.access_token ?? null;
}
